import { render } from "./engagement-item.vue?vue&type=template&id=647d75ce&scoped=true"
import script from "./engagement-item.vue?vue&type=script&lang=js"
export * from "./engagement-item.vue?vue&type=script&lang=js"

import "./engagement-item.vue?vue&type=style&index=0&id=647d75ce&scoped=true&lang=scss"

import exportComponent from "/apps/gitlab/t2_tHNRGy/0/ecis/caap/launch/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647d75ce"]])

export default __exports__